import React from "react";
import {
  AppContainer,
  CardTitle,
  InfoCard,
  InfoRow,
  Label,
  MainContent,
  PermissionBadge,
  PermissionsGrid,
  ProfileAvatar,
  ProfileContainer,
  ProfileImageContainer,
  ProfileImageSection,
  StatusBadge,
  Value,
} from "./style";

const AdminProfile = ({ admin }) => {
  const defaultProfileImage = `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
    admin.name,
  )}&size=200&backgroundType=gradientLinear&fontWeight=500`;

  const permissionTranslations = {
    MAP: "الخريطة",
    DRIVER_ACTIONS: "إجراءات السائقين",
    DRIVERS: "إدارة السائقين",
    USERS: "إدارة المستخدمين",
    BALANCES: "إدارة الرصيد",
    ADMIN_ACCOUNT: "حساب المدير",
    BAG_MANAGER: "امناء الحقائب",
  };

  return (
    <AppContainer>
      <ProfileContainer>
        <ProfileImageSection>
          <ProfileImageContainer>
            <ProfileAvatar
              src={admin.profile_img || defaultProfileImage}
              alt={admin.name}
              onError={(e) => {
                e.target.src = defaultProfileImage;
              }}
            />
          </ProfileImageContainer>
          <StatusBadge isActive={admin.is_active}>
            {admin.is_active ? "نشط" : "غير نشط"}
          </StatusBadge>
        </ProfileImageSection>

        <MainContent>
          <InfoCard>
            <CardTitle>معلومات المدير</CardTitle>
            <InfoRow>
              <Label>الاسم الكامل:</Label>
              <Value>{admin.name}</Value>
            </InfoRow>
            <InfoRow>
              <Label>البريد الإلكتروني:</Label>
              <Value>{admin.email}</Value>
            </InfoRow>
            <InfoRow>
              <Label>رقم الهاتف:</Label>
              <Value>{admin.phone_number}</Value>
            </InfoRow>
            <InfoRow>
              <Label>رقم المعرف:</Label>
              <Value>{admin._id}</Value>
            </InfoRow>
          </InfoCard>

          <InfoCard>
            <CardTitle>الصلاحيات</CardTitle>
            <PermissionsGrid>
              {admin.permissions.map((permission) => (
                <PermissionBadge key={permission}>
                  {permissionTranslations[permission] || permission}
                </PermissionBadge>
              ))}
            </PermissionsGrid>
          </InfoCard>
        </MainContent>
      </ProfileContainer>
    </AppContainer>
  );
};

export default AdminProfile;
